import { jsx as _jsx } from "react/jsx-runtime";
import NativePictureInPicture from "../specs/OneNativePictureInPictureNativeComponent";
function PictureInPicture(param) {
  var { active = false, autoEnter = false, onActiveChange, ...props } = param;
  return /* @__PURE__ */ _jsx(NativePictureInPicture, {
    ...props,
    active,
    autoEnter,
    onNativePictureInPictureChange: function onNativePictureInPictureChange(param2) {
      var { nativeEvent } = param2;
      return onActiveChange === null || onActiveChange === void 0 ? void 0 : onActiveChange(nativeEvent.active);
    }
  });
}
export {
  PictureInPicture
};
//# sourceMappingURL=PictureInPicture.native.js.map
